import React, { useEffect } from "react";
import Successfull_Lottie from "../animation/Successfull_Lottie/Successfull_Lottie";
import "./Thank_You.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const Thank_You = () => {
  const navigate = useNavigate();

  // useEffect(() => {

  //     if (typeof window.gtag === 'function') {
  //         window.gtag('event', 'conversion', {
  //             send_to: 'AW-16713947906/5GH1COmCs_gaEIK26qE-',
  //             value: 1.0,
  //             currency: 'INR'
  //         });
  //     }
  // }, []);

  // old 03/12

  // useEffect(() => {
  //     const gtag_report_conversion = (url) => {
  //         const callback = function () {
  //             if (typeof url !== 'undefined') {
  //                 window.location = url;
  //             }
  //         };
  //         window.gtag && window.gtag('event', 'conversion', {
  //             send_to: 'AW-16713947906/L97ZCNrgtfoaEIK26qE-',
  //             value: 1.0,
  //             currency: 'INR',
  //             event_callback: callback
  //         });
  //         return false;
  //     };

  //     gtag_report_conversion();
  // }, []);

  // useEffect(() => {
  //   // New Bharat Lead Gen Conversion Script
  //   if (typeof window.gtag === "function") {
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-16713947906/FC_KCMja-8obEIK26qE-",
  //       value: 1.0,
  //       currency: "INR",
  //     });
  //   }
  // }, []);

  useEffect(() => {
    if (typeof window.gtag === "function") {
      // MBA_WXnew (1) conversion
      window.gtag("event", "conversion", {
        send_to: "AW-16713947906/cv1NCOi3hNkbEIK26qE-",
        value: 1.0,
        currency: "INR",
      });
    }
  }, []);
  return (
    <section className="Thank_You">
      <div className="container">
        <div className="main_div">
          <div className="lottie_holder">
            <Successfull_Lottie />
          </div>
          <p className="success_text">
            Thank you! Your enquiry has been submitted successfully.
          </p>
          <p className="success_text">We’ll get back to you shortly.</p>
          <p className="back_text" onClick={() => navigate("/")}>
            <FontAwesomeIcon icon={faArrowLeft} className="back_icon" /> Back to
            Home
          </p>
        </div>
      </div>
    </section>
  );
};

export default Thank_You;
